import React from 'react';
import { useGlobalContext } from './context';
import CartIcon from './CartIcon';

const Navbar = () => 
{
  const { amount } = useGlobalContext();
  return (
    <nav>
      <div className='nav-center'>
        <h3>E-Commerce</h3>
        <div className='nav-container'>
          <CartIcon/>         
          <div className='amount-container'>
            <p className='total-amount'>{amount}</p>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar;
